export default __webpack_public_path__ + "static/media/consultorWhite.30d3b96e.svg";